import BookEditorShell from "./BookEditorShell";
import WriteMode from "./modes/WriteMode";
import DesignMode from "./modes/DesignMode";
import CanvasMode from "./modes/CanvasMode";
import PreviewMode from "./modes/PreviewMode";
import { useBookEditor } from "./BookEditorProvider";

export default function UnifiedBookEditor() {
  const { mode } = useBookEditor();

  return (
    <BookEditorShell>
      {mode === "write" && <WriteMode />}
      {mode === "design" && <DesignMode />}
      {mode === "canvas" && <CanvasMode />}
      {mode === "preview" && <PreviewMode />}
    </BookEditorShell>
  );
}
